import {
  f1LogoBlanco,
  kylieLogoBlanco,
  nissanLogoBlanco,
  volvoLogoBlanco,
} from '../assets/images/logo';
import {
  f1PortadaHome,
  kyliePortadaHome,
  nissanPortadaHome,
  volvoPortadaHome,
} from '../assets/images/projects';

export const PROJECTS = [
  {
    id: 'f1',
    name: 'Formula 1',
    logo: f1LogoBlanco,
    image: f1PortadaHome,
    galleryImages: [f1PortadaHome],
    brandColor: '#FF1E00',
  },
  {
    id: 'kylie',
    name: 'Kylie Cosmetics',
    logo: kylieLogoBlanco,
    image: kyliePortadaHome,
    galleryImages: [kyliePortadaHome],
    brandColor: '#FFB3BA',
  },
  {
    id: 'nissan',
    name: 'Nissan',
    logo: nissanLogoBlanco,
    image: nissanPortadaHome,
    galleryImages: [nissanPortadaHome],
    brandColor: '#C3002F',
  },
  {
    id: 'volvo',
    name: 'Volvo',
    logo: volvoLogoBlanco,
    image: volvoPortadaHome,
    galleryImages: [volvoPortadaHome],
    brandColor: '#003057',
  },
];
